/**
 * Fanta Spacing from
 * https://app.zeplin.io/project/5bec9584b557d82929fe8641/screen/5bef24d33901503f0b572783
 */
var spacing;

(function (spacing) {
  spacing["px4"] = "0.25rem";
  spacing["px8"] = "0.5rem";
  spacing["px12"] = "0.75rem";
  spacing["px16"] = "1rem";
  spacing["px24"] = "1.5rem";
  spacing["px32"] = "2rem";
  spacing["px40"] = "2.5rem";
  spacing["px48"] = "3rem";
  spacing["px64"] = "4rem";
  spacing["px80"] = "5rem";
  spacing["px96"] = "6rem";
  spacing["px112"] = "7rem";
  spacing["px128"] = "8rem";
  spacing["px144"] = "9rem";
  spacing["px160"] = "10rem";
})(spacing || (spacing = {}));

export default spacing;